import React, { useEffect } from 'react';
import { actions, useAppDispatch, useSelectAuthentication } from '../../../../store';
import classes from './index.module.scss';

/**
 * Props interface for the PageWrapper component
 */
interface Props {
	/** Content to render inside the wrapper */
	children: React.ReactNode;
	/** Additional CSS class names */
	className?: string;
}

/**
 * PageWrapper component
 * Provides a consistent wrapper for all pages
 * Handles fetching application settings when authenticated
 *
 * @param {Props} props - Component props
 * @returns {JSX.Element} - Rendered component
 */
const PageWrapper = ({ className = '', children }: Props) => {
	// Redux dispatch for actions
	const dispatch = useAppDispatch();
	// Authentication state from Redux
	const authenticationState = useSelectAuthentication();

	/**
	 * Fetch application settings when authenticated
	 * Only runs when authentication state changes
	 */
	useEffect(() => {
		if (authenticationState.isAuthenticated) {
			dispatch(actions.fetchSettings());
		}
	}, [dispatch, authenticationState.isAuthenticated]);

	// Combine base class with any custom classes
	const combinedClassNames = `${classes['pageWrapper']} ${className}`;

	return <div className={combinedClassNames}>{children}</div>;
};

export default PageWrapper;
